import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getGuideList,
	getGuidesFlat,
	addNewGuide,
	updateGuide,
	deleteGuide,
	getGuide,
	getDetailGuide,
	getRegisterGuide,
	registerGuide,
	finalDestinationReceptionGuide,
	finalDestinationPrecertificationGuide,
	finalDestinationCertificationGuide,
	warehouseReceptionGuide,
	warehouseSendGuide,
	statementGuide,
	getFolderPaths,
	getStatusGuide
} from '../guide/thunk';

export const initialState = {
	itemGuideList: [],
	itemGuide: null,
	isGuideLoading: false,
	isGuideSuccess: false,

	guidesFlat: [],
	guidesFlatTotal: 0,
	isGuidesFlatLoading: false,
	isGuidesFlatLoaded: false,
	isGuidesFlatError: false,

	statusGuideList: [],

	dataGuide: null,
	guideList: [],
	guideListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	isReceiving: false,
	isReceived: false,
	isReceptionError: false,
	isSending: false,
	isSended: false,
	isSendError: false,
	isPrecertifying: false,
	isPrecertified: false,
	isPrecertifiedError: false,
	isCertifying: false,
	isCertified: false,
	isCertifiedError: false,
	isStatementing: false,
	isStatemented: false,
	isStatementError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,

	isLoading: false,
    isLoaded: false,
    isError: false,
    error: null,
    folderPaths: [],
};

const GuideSlice = createSlice({
	name: 'Guides',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		setRequireReloadSelectionItemsGrid(state, action) {
			state.requireReloadSelectionItemsGrid = action.payload;
		},
		cleanDataGuide(state, action) {
			state.dataGuide = null;
		},
		restartRegisterGuide(state, action) {
			state.isAdding = false;
			state.isAdded = false;
			state.registerDisabled = false;
		},
		restartStatement(state, action) {
			state.isStatementing = false;
			state.isStatemented = false;
			state.isStatementError = false;
		},
	},
	extraReducers: builder => {
		builder.addCase(getGuide.fulfilled, (state, action) => {
			state.isGuideLoading = false;
			state.isGuideSuccess = true;
			state.itemGuide = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getGuide.pending, state => {
			state.isGuideLoading = true;
			state.isGuideSuccess = null;
			state.itemGuide = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getGuide.rejected, (state, action) => {
			state.isGuideLoading = false;
			state.isGuideSuccess = false;
			state.itemGuide = null;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		
		builder.addCase(getDetailGuide.fulfilled, (state, action) => {
			state.isGuideLoading = false;
			state.isGuideSuccess = true;
			state.itemGuideList = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getDetailGuide.pending, state => {
			state.isGuideLoading = true;
			state.isGuideSuccess = null;
			state.itemGuide = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getDetailGuide.rejected, (state, action) => {
			state.isGuideLoading = false;
			state.isGuideSuccess = false;
			state.itemGuide = null;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getGuideList.pending, state => {
			state.isGuideSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getGuideList.fulfilled, (state, action) => {
			state.itemGuideList = action.payload;
			state.guideList = action.payload;
			state.isLoadingList = false;
			state.isGuideSuccess = true;

			let guideListSelect = [];
			action.payload.map(item =>
				guideListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.guideListSelect = guideListSelect;
		});
		builder.addCase(getGuideList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isGuideSuccess = true;
		});

		// getGuidesFlat cases
		builder.addCase(getGuidesFlat.pending, state => {
			state.isGuidesFlatLoading = true;
			state.isGuidesFlatLoaded = false;
			state.isGuidesFlatError = false;
			state.error = null;
		});
		builder.addCase(getGuidesFlat.fulfilled, (state, action) => {
			state.isGuidesFlatLoading = false;
			state.isGuidesFlatLoaded = true;
			const p = action.payload;
			state.guidesFlat = p?.data ?? [];
			state.guidesFlatTotal = p?.meta?.totalCount ?? 0;
		});
		builder.addCase(getGuidesFlat.rejected, (state, action) => {
			state.isGuidesFlatLoading = false;
			state.isGuidesFlatLoaded = false;
			state.isGuidesFlatError = true;
			state.error = action.error.message;
		});

		builder.addCase(addNewGuide.fulfilled, (state, action) => {
			state.itemGuideList.push(action.payload);
			state.guideList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewGuide.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewGuide.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateGuide.fulfilled, (state, action) => {
			state.itemGuideList = state.itemGuideList.map(guide =>
				guide.guidename === action.payload.old_guide
					? { ...guide, ...action.payload.updated_guide }
					: guide
			);
			state.guideList = state.guideList.map(guide =>
				guide._id.toString() === action.payload._id.toString()
					? { ...guide, ...action.payload }
					: guide
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateGuide.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateGuide.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteGuide.fulfilled, (state, action) => {
			state.itemGuideList = current(state.itemGuideList).filter(
				item => item._id !== action.payload._id
			);
			state.guideList = current(state.guideList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteGuide.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteGuide.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
		builder.addCase(getRegisterGuide.fulfilled, (state, action) => {
			state.isGuideLoading = false;
			state.isGuideSuccess = true;
			state.dataGuide = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getRegisterGuide.pending, state => {
			state.dataGuide = null
			state.isGuideLoading = true;
			state.isGuideSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getRegisterGuide.rejected, (state, action) => {
			state.dataGuide = null
			state.isGuideLoading = false;
			state.isGuideSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});
		builder.addCase(registerGuide.fulfilled, (state, action) => {
			state.registerDisabled = true;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
		});
		builder.addCase(registerGuide.pending, state => {
			state.registerDisabled = false;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(registerGuide.rejected, (state, action) => {
			state.registerDisabled = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
			state.requireCloseModal = true;
			state.error = action.error.message;
		});
		builder.addCase(finalDestinationReceptionGuide.fulfilled, (state, action) => {
			state.isReceiving = false;
			state.isReceived = true;
			state.isReceptionError = false;
			state.requireCloseModal = true;
			state.requireReloadSelectionItemsGrid = true;
		});
		builder.addCase(finalDestinationReceptionGuide.pending, state => {
			state.isReceiving = true;
			state.isReceived = false;
			state.isReceptionError = false;
		});
		builder.addCase(finalDestinationReceptionGuide.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isReceiving = false;
			state.isReceived = false;
			state.isReceptionError = false;
			state.requireCloseModal = false;
		});
		builder.addCase(finalDestinationPrecertificationGuide.fulfilled, (state, action) => {
			state.isPrecertifying = false;
			state.isPrecertified = true;
			state.isPrecertifiedError = false;
			state.requireCloseModal = true;
			state.requireReloadSelectionItemsGrid = true;
		});
		builder.addCase(finalDestinationPrecertificationGuide.pending, state => {
			state.isPrecertifying = true;
			state.isPrecertified = false;
			state.isPrecertifiedError = false;
		});
		builder.addCase(finalDestinationPrecertificationGuide.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isPrecertifying = false;
			state.isPrecertified = false;
			state.isPrecertifiedError = false;
			state.requireCloseModal = false;
		});
		builder.addCase(finalDestinationCertificationGuide.fulfilled, (state, action) => {
			state.isCertifying = false;
			state.isCertified = true;
			state.isCertifiedError = false;
			state.requireCloseModal = true;
			state.requireReloadSelectionItemsGrid = true;
		});
		builder.addCase(finalDestinationCertificationGuide.pending, state => {
			state.isCertifying = true;
			state.isCertified = false;
			state.isCertifiedError = false;
		});
		builder.addCase(finalDestinationCertificationGuide.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isCertifying = false;
			state.isCertified = false;
			state.isCertifiedError = false;
			state.requireCloseModal = false;
		});
		builder.addCase(warehouseReceptionGuide.fulfilled, (state, action) => {
			state.isReceiving = false;
			state.isReceived = true;
			state.isReceptionError = false;
			state.requireCloseModal = true;
			state.requireReloadSelectionItemsGrid = true;
		});
		builder.addCase(warehouseReceptionGuide.pending, state => {
			state.isReceiving = true;
			state.isReceived = false;
			state.isReceptionError = false;
		});
		builder.addCase(warehouseReceptionGuide.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isReceiving = false;
			state.isReceived = false;
			state.isReceptionError = false;
			state.requireCloseModal = false;
		});
		builder.addCase(warehouseSendGuide.fulfilled, (state, action) => {
			state.isSending = false;
			state.isSended = true;
			state.isSendError = false;
			state.requireCloseModal = true;
			state.requireReloadSelectionItemsGrid = true;
		});
		builder.addCase(warehouseSendGuide.pending, state => {
			state.isSending = true;
			state.isSended = false;
			state.isSendError = false;
		});
		builder.addCase(warehouseSendGuide.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isSending = false;
			state.isSended = false;
			state.isSendError = false;
			state.requireCloseModal = false;
		});
		builder.addCase(statementGuide.fulfilled, (state, action) => {
			state.isStatementing = false;
			state.isStatemented = true;
			state.isStatementError = false;
			state.requireCloseModal = true;
			state.requireReloadSelectionItemsGrid = true;
		});
		builder.addCase(statementGuide.pending, state => {
			state.isStatementing = true;
			state.isStatemented = false;
			state.isStatementError = false;
		});
		builder.addCase(statementGuide.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isStatementing = false;
			state.isStatemented = false;
			state.isStatementError = false;
			state.requireCloseModal = false;
		});
		builder.addCase(getFolderPaths.fulfilled, (state, action) => {
            state.isLoading = false;
            state.isLoaded = true;
            state.isError = false;
            state.folderPaths = action.payload;
        });
        builder.addCase(getFolderPaths.pending, (state) => {
            state.isLoading = true;
            state.isLoaded = false;
            state.isError = false;
            state.folderPaths = [];
        });
        builder.addCase(getFolderPaths.rejected, (state, action) => {
            state.isLoading = false;
            state.isLoaded = false;
            state.isError = true;
            state.error = action.error.message || null;
            state.folderPaths = [];
        });
		builder.addCase(getStatusGuide.fulfilled, (state, action) => {
            state.isLoading = false;
            state.isLoaded = true;
            state.isError = false;
            state.statusGuideList = action.payload;
        });
        builder.addCase(getStatusGuide.pending, (state) => {
            state.isLoading = true;
            state.isLoaded = false;
            state.isError = false;
            state.folderPaths = [];
        });
        builder.addCase(getStatusGuide.rejected, (state, action) => {
            state.isLoading = false;
            state.isLoaded = false;
            state.isError = true;
            state.error = action.error.message || null;
            state.folderPaths = [];
        });

		
	},
});

export const {
	setRequireCloseModal,
	setRequireReloadSelectionItemsGrid,
	cleanDataGuide,
	restartRegisterGuide,
	restartStatement
} = GuideSlice.actions;

export default GuideSlice.reducer;
